import { BaseDivider } from "@/shared/ui/base-divider";
import { SidebarListItem } from "@/widgets/sidebar/ui/sidebar-list-item";
import { List } from "@mui/material";

type Props = {
  currentPath: string;
  notificationBadgeNumber: number | undefined;
  logout: () => void;
};

export const CarrierSidebar = ({
  currentPath,
  notificationBadgeNumber,
  logout,
}: Props) => {
  return (
    <>
      <List>
        <SidebarListItem
          href="/notifications"
          text="お知らせ"
          icon="mail"
          isActive={currentPath === "/notifications"}
          badgeNumber={notificationBadgeNumber}
        />

        <SidebarListItem
          href="/carrier/cargos?tab=not_proposed"
          text="荷物一覧"
          icon="search"
          isActive={currentPath === "/carrier/cargos"}
        />
      </List>

      <BaseDivider />

      <List>
        <SidebarListItem
          href="/master-data/vehicles"
          text="車両管理"
          icon="truck"
          isActive={currentPath === "/master-data/vehicles"}
        />
      </List>

      <BaseDivider />

      <List>
        <SidebarListItem
          href="#"
          text="ヘルプ"
          icon="helpCircle"
          isActive={false}
        />
        <SidebarListItem
          text="ログアウト"
          icon="logOut"
          isActive={false}
          onClick={logout}
        />
      </List>
    </>
  );
};
